import { useMemo, useState, type ReactNode } from 'react';
import { BillingModalContext } from './BillingModalContext';
import { PlanModal } from './PlanModal';

export function BillingModalProvider({ children }: { children: ReactNode }) {
  const [planModalOpen, setPlanModalOpen] = useState(false);

  const value = useMemo(
    () => ({
      openPlanModal: () => setPlanModalOpen(true),
    }),
    []
  );

  return (
    <BillingModalContext.Provider value={value}>
      {children}
      <PlanModal open={planModalOpen} onOpenChange={setPlanModalOpen} />
    </BillingModalContext.Provider>
  );
}
